import { Container, Link, Stack, Text } from "basis";
import { Layout } from "components/Layout/Layout";
import { WaysToPayFAQ } from "components/WaysToPay/WaysToPayFAQ";
import { useLocation } from "react-router-dom";
import { CreditCard } from "../../CreditCard/CreditCard";
import { SvgInline } from "../../SvgInline/SvgInline";

interface ErrorLocationState {
  card: {
    cardName: string;
    cardEndsWith: string;
  };
  returnLink: {
    href: string;
    label: string;
  };
}

export const ErrorPage = () => {
  const location = useLocation();
  const state = (location.state as ErrorLocationState) || {};
  return (
    <Layout>
      <Layout.Header>Make a payment</Layout.Header>
      <Layout.Main>
        <Stack gap="8">
          {state.card && (
            <Container bg="grey.t05" padding="4">
              <CreditCard
                cardName={state.card.cardName}
                cardEndsWith={state.card.cardEndsWith}
              />
            </Container>
          )}
          <Stack gap="8">
            <SvgInline name="error-dog" width="236" />
            <Text textStyle="heading5" textStyle-sm="heading4">
              Oops, something went wrong
            </Text>
            <Text>
              It looks like we’re having an unexpected problem and can’t process
              your request. Please try again or{" "}
              <Link href="/contact" newTab={false}>
                contact us
              </Link>{" "}
              so we can help.
            </Text>
            <Link
              appearance="primary-button"
              width="256"
              href={state.returnLink?.href}
              newTab={false}
              onClick={() => {
                if (!state.returnLink) {
                  window.history.back();
                }
              }}
            >
              {state.returnLink?.label || "Back"}
            </Link>
          </Stack>
        </Stack>
      </Layout.Main>
      <Layout.Sidebar>
        <WaysToPayFAQ />
      </Layout.Sidebar>
    </Layout>
  );
};
